import styled from "styled-components";


export const ButtonDefault = styled.a`
  color: #000;
  font-size: 2rem;
  background-color: transparent;
  padding: 1rem 5rem;
  font-weight: bold;
  text-transform: uppercase;
  border: 1px solid #000;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: #F61067;
    background-color: #ffffff;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  @media(max-width: 800px) {
    font-size: 2rem;
    padding: 2.5rem 3.4rem;
    width: 100%;
  }
`

export const ProjectsButton = styled(ButtonDefault)`

  background-color: #D34062;

  &:hover, :active {
    color: #ffffff;
    background-color: transparent;
    border: 1px solid #D34062;
    filter: drop-shadow(0 0 0.3rem #D34062);
  }
`

export const BotButton = styled(ButtonDefault)`
  background-color: #D34062;

  &:hover, :active {
    color: #ffffff;
    background-color: transparent;
    border: 1px solid #D34062;
    filter: drop-shadow(0 0 0.3rem #D34062);
  }
`

export const LangSwitchBtn = styled(ButtonDefault)`
  padding: 10px 51px;
  text-transform: uppercase;  

  @media (max-width: 1024px) {
    padding: 10px;
    align-self: flex-start;
    justify-content: flex-end;
  }
`

export const CookieAcceptBtn = styled(ButtonDefault)`
  font-size: 14pt;
  padding: 0.6rem 1.5rem;
  white-space: nowrap;
  flex-shrink: 0;

  @media (max-width: 1024px) {
    font-size: 12pt;
  }

  @media (max-width: 800px) {
    font-size: 11pt;
    padding: 0.5rem 1rem;
    width: auto;
    align-self: flex-end;
  }

  @media (max-width: 400px) {
    font-size: 10pt;
  }
`